import React, { useState } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import CustomModal from '../../../components/modales/customModal';
import {
    useNavigate
} from "react-router-dom";

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const editarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

const ModalCancelacion = (props)=>{
    const navigate  = useNavigate();
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [observacion, setObservacion]= useState('')
    const [cancelando, setCancelando]= useState(false)

    const cambioEstadoEnDB = async () => {
        try {
            let body = {
                cod_soli: props.id,
                cod_empr: userData.codigoEmpresa,
                data: {
                    cmp_stat: 'CANCELADA'
                }
            }
            await editarAPE(body);
            navigate('/home/procesos');
            toastSuccess(`Solicitud ${props.id} Cancelada`);
        }
        catch (error) {
            toastError('Error al cancelar!')
            console.log(error);
        }
    }

    const cancelarSolicitud =()=>{
        try {
            setCancelando(true)
            cambioEstadoEnDB()
            props.action()
            setCancelando(false)
            props.toggle()
        }
        catch (error) {
            console.log(error)
        }
        
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Cancelar Solicitud'}
                buttonTitle={'Cancelar'}
                onClick={() => cancelarSolicitud()}
                buttonLoading={cancelando}
            >
                <Input type="textarea" name="input_observacionCancelacion" defaultValue={observacion} onChange={(e) => setObservacion(e.target.value)} id="observacionCancelacion" />
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalCancelacion);